/* eslint no-shadow: */
export enum TYPE_PROMOTION {
  RECLAMEAQUI = 'RECLAMEAQUI',
  BLOQUEIOS = 'BLOQUEIOS',
  ABASTECIMENTO = 'ABASTECIMENTO',
  UPDATEPROFILE = 'UPDATEPROFILE',
  NPS = 'NPS',
  REFUEL = 'REFUEL',
  PESQUISA_USABILIDADE = 'PESQUISA_USABILIDADE',
  AVISO_MFA = 'AVISO_MFA',
  AVISO_PIX = 'AVISO_PIX',
  INCIDENTES_RS = 'INCIDENTES_RS',
}
